import(/* webpackMode: "eager", webpackExports: ["RichTextExpandableImage"] */ "/opt/hotlistcasino/frontend/src/components/blog/RichTextExpandableImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Breadcrumbs"] */ "/opt/hotlistcasino/frontend/src/components/Breadcrumbs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FavoriteButton"] */ "/opt/hotlistcasino/frontend/src/components/FavoriteButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NativeImageWithLoader","NextImageWithLoader"] */ "/opt/hotlistcasino/frontend/src/components/ImageWithLoader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LocalizedLink"] */ "/opt/hotlistcasino/frontend/src/components/LocalizedLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MotionReveal"] */ "/opt/hotlistcasino/frontend/src/components/MotionReveal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PaymentMethodIcons"] */ "/opt/hotlistcasino/frontend/src/components/PaymentMethodIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReviewForm"] */ "/opt/hotlistcasino/frontend/src/components/ReviewForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReviewList"] */ "/opt/hotlistcasino/frontend/src/components/ReviewList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SafeGameImage"] */ "/opt/hotlistcasino/frontend/src/components/SafeGameImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScreenshotCarousel"] */ "/opt/hotlistcasino/frontend/src/components/ScreenshotCarousel.tsx");
